import { PageSectionsCalloutCardWithImageCalloutCardCalloutContentFeatureList } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { tinaField } from 'tinacms/dist/react';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { FramedFeatureIcon, FramedFeatureIconProps } from './FramedFeatureIcon';
export type FeatureListType = PageSectionsCalloutCardWithImageCalloutCardCalloutContentFeatureList | PageSectionsCalloutCardWithImageCalloutCardCalloutContentFeatureList;
export interface IconFeatureListProps {
  data?: FeatureListType;
}
export interface IconFeatureProps {
  icon?: FramedFeatureIconProps['icon'];
  text?: string;
}
export function IconFeatureList({
  data
}: IconFeatureListProps) {
  return data ? <ul className="x1717udv x1ghz6dp x78zum5 xdt5ytf x16pmaob">
      {data?.features ? data.features.map((feature, i) => feature?.text ? <li key={`${i}-${feature.icon}-${feature.text.replace(/\s/, '-')}`} className="x78zum5 x6s0dn4 x1p83jl1 x1ghz6dp x1717udv" data-tina-field={tinaField(feature, 'text')}>
                {feature.icon && <FramedFeatureIcon icon={feature.icon as 'Diamond'} />}
                <p {...stylex.props([typography.heading3])}>{feature.text}</p>
              </li> : null) : null}
    </ul> : null;
}